<script>
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { isValid } from "../../validation";
	import { registerPageComplete } from "../../tealium";

	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import CheckboxButton from "../../components/CheckboxButton.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import TextArea from "../../components/TextArea.svelte";
	import CancerDiagnosisList from "../../components/CancerDiagnosisList.svelte";
	import SaveAndClose from "../../components/SaveAndClose.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	// props
	export let pageName = null;
	export let persistUrl = null;
	export let pageTitle = null;
	export let disabled = false;
	export let lastVisitedPage = null;

	export let missingDiagnosisError = null;

	let validated = false,
		diagnosisValid = false,
		buttons = null;

	// component state updating
	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = [...isValid(), ...customValidator()];

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
				//displayError(response);
			} else {
				registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);
				buttons.next();
			}
		} else {
			if (errors[0]) {
				errors[0].scrollIntoView({ behavior: "smooth" });
			}
		}

		buttons.unblock();
	};

	const customValidator = () => {
		validated = true;

		if (!diagnosisValid) {
			return [missingDiagnosisError];
		}

		return [];
	};

	const handleNoneOfAboveChange = async (e) => {
		diagnosisValid = false;
		if (e.target.checked) {
			diagnosisValid = true;
			$model.diagnosisOfCancer.cancerDiagnoses.forEach((c) => {
				c.checked = false;
			});
		}
	};

	const handleDiagnosisChange = async (e) => {
		if (e.detail.target.checked) {
			$model.diagnosisOfCancer.noneOfAbove = false;
			diagnosisValid = true;
		} else {
			diagnosisValid = $model.diagnosisOfCancer.cancerDiagnoses.some((_) => _.checked);
		}
	};

	const initialise = () => {
		diagnosisValid =
			$model.diagnosisOfCancer.noneOfAbove ||
			$model.diagnosisOfCancer.cancerDiagnoses.filter((c) => c.checked).length > 0;
	};

	initialise();
</script>

<section>
	<Form {disabled} id="form-diagnosis" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Diagnosis of Cancer</h1>
				<p>
					If you are unable to complete any part of this section of the form, we are here to assist you.
					Please contact us on <ClassActionPhoneNumber /> or via email to <ClassActionEmailAddress />.
				</p>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<p>
				<strong>
					Have you been diagnosed with one of the following types of cancer? Select any relevant and provide
					the approximate date of initial diagnosis for each selection.
				</strong>
			</p>

			<div class="shadowed-box mt-3" class:invalid={validated && !diagnosisValid}>
				<CancerDiagnosisList
					{disabled}
					on:diagnosis-change={handleDiagnosisChange}
					bind:cancerDiagnoses={$model.diagnosisOfCancer.cancerDiagnoses}
				/>

				{#if !disabled || $model.diagnosisOfCancer.noneOfAbove}
					<FormRow class="mt-2">
						<FormColumn cols="3">
							<CheckboxButton
								{disabled}
								on:change={handleNoneOfAboveChange}
								bind:checked={$model.diagnosisOfCancer.noneOfAbove}
								label="None of the above"
								id="diag_none"
							></CheckboxButton>
						</FormColumn>
					</FormRow>
				{/if}

				{#if validated && !diagnosisValid}
					<div bind:this={missingDiagnosisError} class="error-message">
						Please select a diagnosis, or <b>None of the above</b>
					</div>
				{/if}
			</div>
		</div>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<SaveAndClose>Save and Close</SaveAndClose>
			</FormColumn>
		</FormRow>

		<FormRow class="confirmation-hide">
			<FormColumn>
				<NavigationButtons bind:buttons nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>
</section>
